import { memo, useState } from 'react';

import { useClickstreamCallback } from '@zenbusiness/application-commons-clickstream';
import FormControl from '@zenbusiness/zui/FormControl';
import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import Radio from '@zenbusiness/zui/Radio';
import RadioGroup from '@zenbusiness/zui/RadioGroup';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import { cashFlowOptions } from './constants/cashFlow';

const CashFlowUIField = ({
  field = { setSaved: () => {}, setLoading: () => {} },
  value = '',
  dataChangeHandler = () => {},
  disabled
}) => {
  const [selectedValue, setSelectedValue] = useState(value ?? '');
  const trackCashFlowChangeClick = useClickstreamCallback('buttonPressed');
  const handleDataChange = (event) => {
    const newValue = event.target.value;
    setSelectedValue(newValue);
    if (newValue) {
      field.setLoading();
    }

    dataChangeHandler(
      !!newValue,
      { cashFlow: event.target.value },
      (forceUpdate, { isSave, isError }) => {
        field.setSaved(isSave, isError);
        forceUpdate();
      }
    );

    /**
     * Tracking Details: Tracking added to what your cash flow looks like
     * Question: How many user click what your cash flow looks like Field?
     */
    trackCashFlowChangeClick({
      elementText: newValue,
      elementName: 'banking_collect_info',
      appPageName: 'banking_application'
    });
  };

  return (
    <FormControl disabled={disabled}>
      <RadioGroup
        onChange={handleDataChange}
        sx={{ gap: '24px' }}
        value={selectedValue}
      >
        {cashFlowOptions.map(({ value: optionValue, label }) => (
          <FormControlLabel
            control={<Radio />}
            key={optionValue}
            label={<Text size="xl">{label}</Text>}
            value={optionValue}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};

CashFlowUIField.propTypes = {
  value: PropTypes.string,
  dataChangeHandler: PropTypes.func,
  field: PropTypes.shape({
    setSaved: PropTypes.func,
    setLoading: PropTypes.func,
    key: PropTypes.string
  }),
  disabled: PropTypes.bool
};

function areEqual(preProp, nextProp) {
  return (
    preProp.field === nextProp.field &&
    preProp.value === nextProp.value &&
    preProp.disabled === nextProp.disabled
  );
}

export default memo(CashFlowUIField, areEqual);
